var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4714)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 35.75H23C17.57 35.75 15.25 33.43 15.25 28V22C15.25 16.57 17.57 14.25 23 14.25H29C34.43 14.25 36.75 16.57 36.75 22V28C36.75 33.43 34.43 35.75 29 35.75ZM23 15.75C18.39 15.75 16.75 17.39 16.75 22V28C16.75 32.61 18.39 34.25 23 34.25H29C33.61 34.25 35.25 32.61 35.25 28V22C35.25 17.39 33.61 15.75 29 15.75H23Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8298 25.6799C28.4198 25.6799 28.0798 25.3399 28.0798 24.9299V21.4399H24.5898C24.1798 21.4399 23.8398 21.0999 23.8398 20.6899C23.8398 20.2799 24.1798 19.9399 24.5898 19.9399H28.8298C29.2398 19.9399 29.5798 20.2799 29.5798 20.6899V24.9299C29.5798 25.3399 29.2398 25.6799 28.8298 25.6799Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1699 27.0901C22.9799 27.0901 22.7899 27.0201 22.6399 26.8701C22.3499 26.5801 22.3499 26.1001 22.6399 25.8101L28.2999 20.1501C28.5899 19.8601 29.0699 19.8601 29.3599 20.1501C29.6499 20.4401 29.6499 20.9201 29.3599 21.2101L23.6999 26.8701C23.5599 27.0201 23.3599 27.0901 23.1699 27.0901Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 31.2302C23.89 31.2302 21.7699 30.8902 19.7599 30.2202C19.3699 30.0902 19.1599 29.6602 19.2899 29.2702C19.4199 28.8802 19.85 28.6602 20.24 28.8002C23.96 30.0402 28.05 30.0402 31.77 28.8002C32.16 28.6702 32.59 28.8802 32.72 29.2702C32.85 29.6602 32.64 30.0902 32.25 30.2202C30.23 30.9002 28.11 31.2302 26 31.2302Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4714",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4714",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStream);
export default __webpack_public_path__ + "static/media/stream.d3b9c08d23bf4f071313dbc7c5399418.svg";
export { ForwardRef as ReactComponent };